import axios from "axios";

/** Arbitrage Sequences API and the one rule the builder mirrors (ArbitrageSequenceService). */

export const SEQUENCES_URL = "/api/core-list/arbitrage/sequences";

export const fetchSequences = async (storeIdM) => {
  const { data } = await axios.get(SEQUENCES_URL, { params: { store_id_m: storeIdM } });
  return data;
};

export const fetchSequenceResults = async (storeIdM, id, page, perPage) => {
  const { data } = await axios.get(`${SEQUENCES_URL}/${id}/results`, {
    params: { store_id_m: storeIdM, page, per_page: perPage },
  });
  return data;
};

/** Each Prefer's share of the match score: n, n−1 … 1, out of the total. */
export const preferWeights = (filters) => {
  const prefers = filters.filter((f) => f.mode === "prefer");
  const n = prefers.length;
  const total = (n * (n + 1)) / 2;
  return Object.fromEntries(prefers.map((f, i) => [f.key, Math.round(((n - i) / total) * 100)]));
};
